import { useEffect, useRef } from 'react';
//this hook used to get access to previous value. Could be used for example to check which parameter change triggered useEffect call
export const usePreviousValue = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
